import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_FAQ] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.faq = payload
  },
  [types.SET_FAQS] (state, payload) {
    state.faqs = payload.data
    state.pagination = payload.pagination
  }
}
